
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/backyard-design-app",
      function () {
        return require("private-next-pages/backyard-design-app.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/backyard-design-app"])
      });
    }
  